import type { SpotlightBanner } from '@percent/cause-dashboard/storyblok/types/storyblok-components'
import {
  getResolvedNativeApplyContext,
  type NativeApplyModalContext
} from '@percent/cause-dashboard/constants/nativeApply/getResolvedNativeApplyContext'
import { resolveNativeApplyPartnerKey } from '@percent/cause-dashboard/constants/nativeApply/resolveNativeApplyPartner'
import type { SmartApplyPartnerConfigKey } from '@percent/cause-dashboard/constants/smartApplyPartners'

export type SpotlightBannerCta =
  | { kind: 'link'; href: string }
  | { kind: 'native_apply'; partnerKey: SmartApplyPartnerConfigKey; modalContext: NativeApplyModalContext }

export function resolveSpotlightBannerCta(banner: SpotlightBanner): SpotlightBannerCta | null {
  if (banner.cta_type === 'native_apply') {
    const partnerKey = resolveNativeApplyPartnerKey(banner.native_apply_partner)
    const modalContext = getResolvedNativeApplyContext(banner.offer)
    if (!partnerKey || !modalContext) {
      return null
    }
    return { kind: 'native_apply', partnerKey, modalContext }
  }

  const href = banner.cta_link?.trim() ?? ''
  if (!href) {
    return null
  }
  return { kind: 'link', href }
}
